import type { HubDbPoolHolderSnapshot } from "./slowRequestBanner";

export type HubDbPoolHolderStreamStatus = "idle" | "connecting" | "connected" | "disconnected";

export interface HubDbPoolHolderStreamState {
  status: HubDbPoolHolderStreamStatus;
  snapshot: HubDbPoolHolderSnapshot | null;
}

let state: HubDbPoolHolderStreamState = { status: "idle", snapshot: null };
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) {
    listener();
  }
}

function setState(next: HubDbPoolHolderStreamState): void {
  state = next;
  emit();
}

export function subscribeHubDbPoolHolderStream(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getHubDbPoolHolderStreamState(): HubDbPoolHolderStreamState {
  return state;
}

export function resetHubDbPoolHolderStreamStateForTests(): void {
  state = { status: "idle", snapshot: null };
}

export function applyHubLivePoolEvent(event: {
  phase: "connected" | "holders";
  snapshot: HubDbPoolHolderSnapshot;
}): void {
  const snapshot = {
    ...event.snapshot,
    waiters: event.snapshot.waiters ?? [],
  };
  setState({ status: "connected", snapshot });
}

export function markHubDbPoolHolderConnecting(): void {
  if (state.status !== "connected") {
    setState({ status: "connecting", snapshot: state.snapshot });
  }
}

export function markHubDbPoolHolderDisconnected(): void {
  if (state.status !== "disconnected") {
    setState({ status: "disconnected", snapshot: state.snapshot });
  }
}
